@import "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&family=Roboto+Condensed:wght@400;500;600;700&display=swap";

/* src/app/core/pages/sign-up/sign-up.page.scss */
:root {
  --poppins-font: "Poppins", sans-serif;
  --roboto-font: "Roboto Condensed", sans-serif;
}
.w-35px {
  width: 35px;
}
.w-70px {
  width: 70px;
}
.mt-n-3px {
  margin-top: -3px;
}
.mt-n-12px {
  margin-top: -12px;
}
.text-color-secondary {
  color: var(--ion-color-secondary);
}
.border-radius-20px {
  --border-radius: 20px !important;
}
.bg-color-1283f1 {
  --background: #1283f1 !important;
}
.title {
  font-family: "Staatliches";
  color: var(--ion-color-secondary);
  letter-spacing: 5px;
}
.title .dine {
  color: var(--ion-color-tertiary);
}
.password-hint {
  font: normal normal 500 11px/14px Poppins;
}
.password-hint.info {
  color: #f3f3f3 !important;
}
.password-hint.valid {
  color: #1cef76 !important;
}
.password-hint.invalid {
  color: #eb2812 !important;
}
.pwd-visibility-button {
  position: relative !important;
  right: -10px !important;
  transform: translate(5px, 2px) !important;
}
.signup-page-card {
  background:
    linear-gradient(
      to bottom,
      #4DA0B0,
      #D39D38) 0% 0% no-repeat padding-box;
  border-radius: 20px;
  border: 1.5px solid #ccffcc;
  box-sizing: border-box;
  box-shadow: 10px 4px 10px rgba(0, 0, 0, 0.1411764706);
}
.signup-page-card .signup-form-section .form-title {
  font-size: 24px;
  line-height: 28px;
  font-family: var(--poppins-font);
  font-weight: 700;
  color: #ffd949;
}
.signup-page-card .signup-form-section .form-subtitle {
  font-size: 14px;
  font-family: var(--roboto-font);
  font-weight: 600;
  line-height: 21px;
  color: #fbfbfb;
}
.signup-form-section .form-inputs {
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 20px;
  height: 35px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1568627451);
}
.form-inputs .form-input-icon {
  font-size: 20px;
  color: #31b7c2;
  font-family: var(--roboto-font);
}
.signup-form-section .country-code-input {
  font: normal normal normal 14px/21px Poppins;
  color: #c4c5c7;
}
.signup-form-section .terms-conditions-link {
  font-size: 14px;
  line-height: 21px;
  font-weight: 600;
  font-family: var(--roboto-font);
  color: #f2f5fc !important;
}
.signup-form-section .terms-conditions-link :hover {
  color: #008ff2 !important;
  text-decoration: underline !important;
  cursor: pointer !important;
}
.checkbox-input {
  --border-radius: 4px !important;
  --background: #f6f6f7 !important;
  --background-checked: #0089ff !important;
  --border-color-checked: #008ff2 !important;
  --checkmark-width: 2px !important;
}
.form-sub-text {
  font-size: 14px;
  font-family: var(--poppins-font);
  color: #11afee;
}
.error-message {
  font-size: 15px;
  font-weight: 600;
  font-family: var(--roboto-font);
  white-space: wrap !important;
  text-overflow: auto !important;
  color: #f9c35a;
}
.verification-message {
  font-size: 14px;
  font-family: var(--roboto-font);
  font-weight: 600;
  color: #71d81c;
}
.success-verify-icon {
  width: 2em !important;
  height: 2em !important;
}
.success-verify-message {
  font-size: 16px;
  font-family: var(--roboto-font);
  font-weight: 600;
}
.error-message {
  font-size: 14px;
  font-weight: 600;
  font-family: var(--roboto-font);
  white-space: wrap !important;
  color: #db0f0f;
  border-radius: 6px !important;
}
/*# sourceMappingURL=sign-up.page.css.map */
